"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moveInboxRule_1 = require("./actions/moveInboxRule");
exports.moveInboxRule = moveInboxRule_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/lazyIndex.js
// module id = 5175
// module chunks = 2